module.exports = __webpack_public_path__ + "static/media/right_sus_freq.965fa296.png";